<template>
    <div>        
        <div :class="view_class_view.div_container" class="grid grid-cols-1">
            <div class="my-2">
                <label for="input_email">Correo Electrónico:</label>
                <input type="email" id="input_email" name="input_email"  v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: contactInformationModelValidations.email.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!contactInformationModelValidations.email.$invalid, [view_class_view.class_inputs.default ]: contactInformationModelValidations.email.$invalid && !contactInformationModelValidations.email.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="contactInformationModel.email" @blur="contactInformationModelValidations.email.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of contactInformationModelValidations.email.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="my-2">
                <label for="input_telephone">Teléfono fijo:</label>
                <input type="text" id="input_telephone" name="input_telephone" v-maska="'### ###-####'" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: contactInformationModelValidations.telephone.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!contactInformationModelValidations.telephone.$invalid, [view_class_view.class_inputs.default ]: contactInformationModelValidations.telephone.$invalid && !contactInformationModelValidations.telephone.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="contactInformationModel.telephone" @blur="contactInformationModelValidations.telephone.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of contactInformationModelValidations.telephone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div class="my-2">
                <label for="input_anual_income">Celular:</label>
                <input type="text" id="input_anual_income" name="input_anual_income" v-maska="'### ###-####'" v-bind:class="{[ view_class_view.class_inputs.default + view_class_view.class_inputs.no_valid ]: contactInformationModelValidations.cellphone.$error, [view_class_view.class_inputs.default + view_class_view.class_inputs.valid]:!contactInformationModelValidations.cellphone.$invalid, [view_class_view.class_inputs.default ]: contactInformationModelValidations.cellphone.$invalid && !contactInformationModelValidations.cellphone.$error }" class="w-full py-2 px-2 rounded-md border-2 border-sm mb-2 mt-2 shadow-md focus:outline-none" v-model="contactInformationModel.cellphone" @blur="contactInformationModelValidations.cellphone.$validate">
                
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of contactInformationModelValidations.cellphone.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { helpers, requiredIf } from "@vuelidate/validators";

export default {
    name: 'QuotationContactInformation',
    props: {
        view_class_view: {
            type: Object,
            required: true,
            default(){
                return {
                    title: "",
                    class_inputs:{
                        valid:"border-blue-600",
                        no_valid:"border-red-600",
                        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
                    },
                    div_container_error:{
                        container:"my-2",
                        text_error:"text-red-600",
                    },
                    div_container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
                }
            }
        },
        validations: {
            type: Object,
            required: true,
            default() {
                return {
                    email: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    telephone: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    },
                    cellphone: {
                        required: helpers.withMessage('El campo es requerido', requiredIf(true))
                    }
                };
            }
        }
    },
    setup(props) {

        let contactInformationModel = ref({
            email: "",
            telephone: "",
            cellphone: ""
        });

        const contactInformationModelValidations = useVuelidate(props.validations, contactInformationModel);
       
        function execute_validation() {
            contactInformationModelValidations.value.$validate();
            if(contactInformationModelValidations.value.$error) return null;
            return contactInformationModel.value;
        }

        return {
            contactInformationModel,
            contactInformationModelValidations,
            execute_validation
        }
    }
}

</script>